import { render, staticRenderFns } from "./CustomTaxSelector.vue?vue&type=template&id=3c8964fc&scoped=true&"
import script from "./CustomTaxSelector.vue?vue&type=script&lang=js&"
export * from "./CustomTaxSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8964fc",
  null
  
)

export default component.exports